import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-recommend-form__field" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-form__title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "趣味・特技など"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-label-highlight --auto-right1" }, "履")
], -1)
const _hoisted_3 = { class: "p-recommend-form__error-wrap" }
const _hoisted_4 = { class: "p-recommend-form__field" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-form__title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "本人希望記入欄"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-label-highlight --auto-right1" }, "履")
], -1)
const _hoisted_6 = { class: "p-recommend-form__error-wrap" }

import InvalidMessage from '@/components/InvalidMessage.vue';
import ValidatableField from '@/components/ValidatableField.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AdditionalInfoForm',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(InvalidMessage, { name: "hobbySkill" })
      ]),
      _createVNode(ValidatableField, {
        as: "textarea",
        class: "p-recommend-form__textarea",
        id: "form-hobbies",
        type: "textarea",
        name: "hobbySkill",
        placeholder: "例）読書／旅行／映画鑑賞／ランニング",
        label: "趣味・特技など",
        rules: "max:1000",
        maxlength: "1000"
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createVNode(InvalidMessage, { name: "wishOthers" })
      ]),
      _createVNode(ValidatableField, {
        as: "textarea",
        class: "p-recommend-form__textarea",
        id: "form-message",
        type: "textarea",
        name: "wishOthers",
        placeholder: "特に給料・職種・勤務時間・勤務地・その他についての希望などがあれば記入してください",
        label: "本人希望記入欄",
        rules: "max:2000",
        maxlength: "2000"
      })
    ])
  ], 64))
}
}

})